import { CloneQuoteData, GridHelpers, type QuoteData } from '@iqd/shared-quoting/core';
import type { WizardFormValues } from '../schemas';

function applyFireProtection(qd: QuoteData, fireRated: boolean): void {
  qd.GeneralData.IsFireRated = fireRated;
  qd.FireRatingData.CostFireRating = fireRated;
  qd.FireRatingData.CostCeilings = fireRated;
  qd.FireRatingData.CostFascia = fireRated;
  qd.FireRatingData.CostColumnCasings = fireRated;
  // Prime prices the fascia from the length it is sent and never works it out.
  if (fireRated && qd.FireRatingData.FasciaLengthAuto) {
    qd.FireRatingData.FasciaLength = GridHelpers.calculateRoundedPerimeter(qd);
  }
}

function updateAncillaries(qd: QuoteData): void {
  for (const ancillary of qd.AncillaryData.AncillaryArguments) {
    if (ancillary.Height > 0) {
      ancillary.Height = qd.FloorData.TiersData.TierData[0].Height;
    } else if (ancillary.Length > 0) {
      ancillary.Length = qd.FloorData.GridData.XDim * 2 + qd.FloorData.GridData.YDim * 2;
    }
  }
}

export function buildQuoteData(base: QuoteData, value: WizardFormValues): QuoteData {
  const qd = CloneQuoteData(base);
  qd.GeneralData.AreaCode = value.siteAreaCodeId ?? null;
  qd.FloorData.GridData.XDim = Number(value.length);
  qd.FloorData.GridData.YDim = Number(value.width);
  qd.FloorData.TiersData.TierData[0].LoadType =
    value.loadType === '' || value.loadType == null ? null : Number(value.loadType);
  qd.FloorData.TiersData.TierData[0].Height = Number(value.height);
  qd.FloorData.TiersData.TierData[0].CutoutData = [];
  qd.FloorData.TiersData.TierCount = 1;
  applyFireProtection(qd, !!value.fireProtection);
  updateAncillaries(qd);
  return qd;
}
